<!--
/**
 * 动态页脚容器组件 - AdaptiveIntercomFooter
 *
 * 功能描述：
 * 1. 作为页面底部容器，包含动态内容插槽
 * 2. 自动根据内容高度调整客服入口位置
 * 3. 实时响应内容高度变化
 *
 * Slots:
 * @slot default - 底部主要内容区域
 *
 * 使用示例:
 * <AdaptiveIntercomFooter>
 *   您的底部内容
 * </AdaptiveIntercomFooter>
 */
-->
<template>
  <footer
    ref="footerEl"
    v-bind="$attrs"
  >
    <slot />
  </footer>
</template>

<script setup>
import { useIntercomObserver } from './useIntercomObserver'

const footerEl = ref(null)

const { observe } = useIntercomObserver()

onMounted(() => {
  if (footerEl.value) {
    observe(footerEl.value)
  }
})
</script>

<style lang="less">
</style>
